import SanitizedHtml from './SanitizedHtml/SanitizedHtml';

export function RawHtml({ html, className }: { html: string; className?: string }) {
	return <SanitizedHtml html={html} className={className} />;
}
